// src/amplifyConfig.ts
import { Amplify } from "aws-amplify";

// Set REACT_APP_AUTH_ENABLED=false to skip Cognito/AppSync wiring entirely
// (e.g. backend-only work with no AWS connectivity). Defaults to enabled.
export const isAuthEnabled = process.env.REACT_APP_AUTH_ENABLED !== "false";

const isLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

const redirectUrl = isLocalhost
  ? "http://localhost:3000/login"
  : `${window.location.origin}/login`;

const userPoolId = process.env.REACT_APP_COGNITO_POOL_ID || "ap-south-1_SFPwNJ7W5";
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID || "58bt4t5dljpmsnblteca010dd3";
const oauthDomain = process.env.REACT_APP_COGNITO_DOMAIN || "kaagazy-emr.auth.ap-south-1.amazoncognito.com";

// No hardcoded fallback - the previous one was a leaked/stale URL that
// silently masked a missing env var (see ENV_CONFIG_HANDOFF.md section 6).
const appsyncUrl = process.env.REACT_APP_APPSYNC_GRAPHQL_URL || "";
const appsyncRegion = process.env.REACT_APP_APPSYNC_REGION || "ap-south-1";

if (isAuthEnabled && !appsyncUrl) {
  // eslint-disable-next-line no-console
  console.error(
    "[amplifyConfig] REACT_APP_APPSYNC_GRAPHQL_URL not set - real-time " +
    "features will silently fall back to polling. Set it in Amplify " +
    "Console for this branch (ENV_CONFIG_HANDOFF.md section 5)."
  );
}

if (isAuthEnabled) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,

        loginWith: {
          email: true,
          oauth: {
            domain: oauthDomain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [redirectUrl],
            redirectSignOut: [redirectUrl],
            responseType: "code",
          },
        },

        signUpVerificationMethod: "code",
        userAttributes: {
          email: { required: true },
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: appsyncUrl,
        region: appsyncRegion,
        defaultAuthMode: "userPool",
      },
    },
  } as any);
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "[amplifyConfig] REACT_APP_AUTH_ENABLED=false - Cognito/AppSync not " +
    "configured. Note: LoginPage still calls Cognito's signIn() directly, " +
    "so sign-in itself will still fail without a reachable user pool."
  );
}
